import { makeObservable, observable, runInAction } from 'mobx';
import { CouponMetrics, UserCoupon, UserCouponStatus } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';

export class CouponStore {
  @observable
  coupons: UserCoupon[] = [];

  @observable
  isLoading = false;

  @observable
  metrics: CouponMetrics | null = null;

  @observable
  isMetricsLoading = false;

  constructor() {
    makeObservable(this);
  }

  async getUserCoupons(): Promise<void> {
    try {
      runInAction(() => {
        this.isLoading = true;
      });
      const {
        apiFactory: { couponService },
      } = getEnv();
      const coupons = await couponService.getUserCoupons();
      runInAction(() => {
        this.coupons = coupons;
        this.isLoading = false;
      });
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async createUserCoupon(params: {
    org: string;
    name: string;
  }): Promise<{ coupon: UserCoupon | null; status: UserCouponStatus }> {
    try {
      const {
        apiFactory: { couponService },
      } = getEnv();

      const coupon = await couponService.createUserCoupon(params);

      runInAction(() => {
        if (
          coupon &&
          coupon?.status === UserCouponStatus.Valid &&
          coupon.coupon
        ) {
          this.coupons = [...this.coupons, coupon.coupon];
        }
      });

      return coupon;
    } catch (e) {
      console.error(e);
      return { coupon: null, status: UserCouponStatus.Other };
    }
  }

  async getCouponMetrics(): Promise<void> {
    try {
      runInAction(() => {
        this.isMetricsLoading = true;
      });
      const {
        apiFactory: { couponService },
      } = getEnv();
      const metrics = await couponService.getCouponMetrics();
      runInAction(() => {
        this.metrics = metrics;
        this.isMetricsLoading = false;
      });
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.isMetricsLoading = false;
      });
    }
  }
}
